'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getTracking = exports.getTracking = function getTracking(trackingName, tracking) {
  return (tracking || []).filter(function (value) {
    return value.getAttr('event') === trackingName;
  }).map(function (value) {
    return value.getValue();
  });
};
//# sourceMappingURL=tracking.js.map


// WEBPACK FOOTER //
// ./src/helpers/tracking.js